import CompactEventTypeSelect from '~/components/forms/CompactEventTypeSelect';
import CompactBookableResourcesSelect from '~/components/scheduling/CompactBookableResourcesSelect';
import React from 'react';

const SchedulingFilterTypeSettings = ({
    settings,
    setSettings,
    onlyClasses,
}) => {
    return (
        <>
            <div className="input-label mt-4">Show Event Types</div>
            <CompactEventTypeSelect
                value={settings?.eventTypes}
                onChange={value =>
                    setSettings({ ...settings, eventTypes: value })
                }
                defaultAll={true}
                onlyClasses={onlyClasses}
                showEmptyError={true}
            />

            <CompactBookableResourcesSelect
                className="mt-4"
                label="Show People/Things"
                value={settings?.bookableResources}
                onChange={value =>
                    setSettings({ ...settings, bookableResources: value })
                }
                hideIfOneType={true}
            />
        </>
    );
};

export default SchedulingFilterTypeSettings;
